module.exports = __webpack_public_path__ + "img/icon_star_rate_inactive.81987e81.svg";